export default __webpack_public_path__ + "static/media/cp_geo_as.e855dcb3.svg";